import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import AuthService from "services/auth.service";
import { useAudio } from "app/OnDemandAlertContext";

function CallAlertsPromptModal() {
  const currentUser = AuthService.getCurrentUser();
  const { unlock } = useAudio();
  const [show, setShow] = useState(true);

  const dismiss = () => {
    localStorage.setItem(`teleconsult:call-alerts-seen:${currentUser.id}`, true);
    setShow(false);
  };

  const handleEnable = () => {
    unlock();
    dismiss();
  };

  return (
    <Modal
      className="modal-overlay pop-up-modal"
      size="l"
      show={show}
      onHide={dismiss}
      centered
    >
      <Modal.Body>
        <div>
          <div className="title">Enable Call Alerts</div>
          <div className="description">
            Turn on sound alerts so you don't miss an incoming on-demand consultation request. Requests will still appear as a pop-up on screen either way.
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex-column button-footer">
        <button
          className="btn btn-link download-button"
          onClick={handleEnable}
        >
          <>Enable Call Alerts</>
        </button>
        <button className={"btn btn-link later-button"} onClick={dismiss}>
          <>Not Now</>
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default CallAlertsPromptModal;
